import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import { NAV, SITE, waLink } from "@/lib/site";
import { InstagramIcon, WhatsAppIcon } from "./BrandIcons";

const Col = ({ title, children }) => (
  <div>
    <h3 className="mb-5 font-sans text-[11px] font-medium uppercase tracking-[0.28em] text-gold">{title}</h3>
    <div className="flex flex-col gap-3 text-sm text-white/70">{children}</div>
  </div>
);

export const Footer = () => (
  <footer className="bg-ink text-white" data-testid="site-footer">
    <div className="container-x py-16 md:py-20">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <img src={SITE.logoLight} alt="Alpha Transfer logo" className="h-12 w-auto" />
          <p className="mt-6 max-w-sm font-serif text-2xl leading-snug text-white/90">
            Arrive in comfort. Explore in style.
          </p>
          <p className="mt-3 text-sm text-white/50">Private transfers and tours in Rhodes, Greece. Available 24/7.</p>
          <p className="mt-4 text-xs tracking-wide text-white/60" data-testid="footer-mhte-number">ΜΗΤΕ: {SITE.mhte}</p>
        </div>
        <div className="md:col-span-3">
          <Col title="Explore">
            {NAV.map((n) => (
              <Link key={n.to} to={n.to} className="transition-colors hover:text-gold" data-testid={`footer-link-${n.label.toLowerCase()}`}>
                {n.label}
              </Link>
            ))}
            <Link to="/booking" className="transition-colors hover:text-gold" data-testid="footer-link-booking">Book a transfer</Link>
          </Col>
        </div>
        <div className="md:col-span-4">
          <Col title="Contact">
            <a href={SITE.phoneHref} className="flex items-center gap-3 hover:text-gold" data-testid="footer-phone-link">
              <Phone className="h-4 w-4" /> {SITE.phoneDisplay}
            </a>
            <a href={waLink()} target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-gold" data-testid="footer-whatsapp-link">
              <WhatsAppIcon className="h-4 w-4" /> WhatsApp
            </a>
            <a href={`mailto:${SITE.email}`} className="flex items-center gap-3 hover:text-gold" data-testid="footer-email-link">
              <Mail className="h-4 w-4" /> {SITE.email}
            </a>
            <a href={SITE.instagramUrl} target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-gold" data-testid="footer-instagram-link">
              <InstagramIcon className="h-4 w-4" /> @{SITE.instagram}
            </a>
          </Col>
        </div>
      </div>
      <div className="mt-14 flex flex-col gap-4 border-t border-white/10 pt-8 text-xs text-white/40 md:flex-row md:items-center md:justify-between">
        <p>© {new Date().getFullYear()} Alpha Transfer, Rhodes. All rights reserved.</p>
        <div className="flex gap-6">
          <Link to="/privacy" className="hover:text-gold" data-testid="footer-privacy-link">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-gold" data-testid="footer-terms-link">Terms</Link>
          <Link to="/admin" className="hover:text-gold" data-testid="footer-admin-link">Owner login</Link>
        </div>
      </div>
    </div>
  </footer>
);
